<template>
  <v-sheet
      ref="sheet"
      :height="height"
      class="overflow-y-auto"
  >
    <div v-if="chatDatasLoading"></div>
    <div v-else-if="chats.length===0">
      <alert>Не найдено</alert>
    </div>
    <v-list v-else class="pa-0" dense>
      <dialog-page-chat-list-item
          v-for="d in chats" :key="d.id"
          :chat="d"
          :selected="localSelectChat?.id===d.id"
          :cat="cat"
          :filterView="filterView"
          :slaTick="slaTick"
          @click="localSelectChat=d"
      />
    </v-list>
  </v-sheet>
</template>

<script>
import Alert from "@/componentsV2/base/Alert.vue";
import axios from "axios";
import DialogPageChatListItem from "./DialogPageChatListItem.vue";

export default {
  components: {DialogPageChatListItem, Alert},
  props: {
    height: {},
    cat: {},
    filterView: {},
    selectChat: {},
    onlyMyChats: {type: Boolean, default: false},
    filterSort: {},
  },
  data: () => ({
    chatDatas: [],
    chats: [],
    chatDatasLoading: false,
    localSelectChat: null,
    subscribeListenerId: null,
    slaTick: 0,
    slaTimer: null,
    loadSeq: 0,
  }),
  mounted() {
    this.localSelectChat = this.selectChat;
    this.load();
    this.$ws.connectWithSubscribeListener(this.$store.state.user, (v) => this.subscribeListenerId = v, (m) => {
      if (m.type === 'dialogChat') {
        if (m.data.cat === 'internal' && !m.data.dialogUsers?.some(v => v.user?.id === this.$store.state.user?.id)) {
          const index = this.chatDatas.findIndex(v => v.id === m.data.id);
          if (index !== -1)
            this.chatDatas.splice(index, 1);
          if (this.localSelectChat?.id === m.data.id)
            this.localSelectChat = null;
          this.chatsFilter();
          return;
        }
        this.dialogChatEvent(m.data, true);
      }
      if (m.type === 'dialogChatUnread') this.dialogChatUnreadEvent(m.data);
    });
    this.slaTimer = setInterval(() => {
      this.slaTick++;
    }, 60000);
  },
  watch: {
    filterView() {
      this.chatsFilter()
    },
    filterSort() {
      this.chatsSort()
    },
    selectChat() {
      this.localSelectChat = this.selectChat
    },
    localSelectChat() {
      this.$emit('update:selectChat', this.localSelectChat)
    },
  },
  beforeDestroy() {
    this.loadSeq++;
    this.setLoading(false);
    this.$ws.removeSubscribeListener(this.subscribeListenerId);
    if (this.slaTimer) {
      clearInterval(this.slaTimer);
    }
  },
  methods: {
    setLoading(v) {
      this.chatDatasLoading = v;
      this.$emit('loading', v);
    },
    load() {
      this.chatDatas = [];
      this.chats = [];
      this.setLoading(true);
      const loadId = ++this.loadSeq;

      let params = [];
      if (this.cat) params.push('cat=' + this.cat.id)

      axios.get('/napi/dialog/chat/?' + params.join('&'))
          .then(r => {
            if (loadId !== this.loadSeq) return;
            r.data.forEach(v => this.dialogChatEvent(v))
            this.setLoading(false);
          })
          .catch(() => {
            if (loadId !== this.loadSeq) return;
            this.setLoading(false);
          });
    },
    dialogChatEvent(data, isEvent = false) {
      const index = this.chatDatas.findIndex(v => v.id === data.id);

      data.blink = isEvent;

      if (index === -1) this.chatDatas.push(data);
      else this.chatDatas[index] = data;

      if (this.localSelectChat?.id === data.id)
        this.localSelectChat = data;

      if (isEvent)
        setTimeout(() => {
          const index = this.chatDatas.findIndex(v => v.id === data.id);
          if (index !== -1) {
            this.chatDatas[index].blink = false;
            this.chatsFilter();
          }
        }, 2000)

      this.chatsFilter();
    },
    dialogChatUnreadEvent(data) {
      const index = this.chatDatas.findIndex(v => v.id === data.id);
      if (index === -1) return;
      this.chatDatas[index]._unreadCount = data.count;
      this.chatsSort();
    },
    chatsFilter() {
      if (this.onlyMyChats || (this.cat?.id === 'process' && this.filterView?.id === 'my')) {
        const userId = this.$store.state.user?.id;
        this.chats = this.chatDatas.filter(chat =>
            chat.dialogUsers?.some(dialogUser => dialogUser.user?.id === userId)
        );
      } else {
        this.chats = this.chatDatas;
      }

      if (this.cat)
        this.chats = this.chats.filter(v => v.cat === this.cat.id)

      this.chatsSort();
    },

    chatsSort() {
      const ts = (c) => {
        const v = c.dialogMesLast?.created || c.created;
        if (!v) return 0;
        const t = Date.parse(String(v).replace(' ', 'T'));
        return Number.isNaN(t) ? 0 : t;
      };
      const priority = this.filterSort?.id !== 'time';
      this.chats = [...this.chats].sort((a, b) => {
        const d = priority ? ts(a) - ts(b) : ts(b) - ts(a);
        return d !== 0 ? d : (priority ? a.id - b.id : b.id - a.id);
      })

      if (this.cat) {
        const chats = this.chats.filter(chat => chat.cat === this.cat.id);
        this.$emit('unreadCount', chats.filter(chat => chat._unreadCount > 0).length);
        this.$emit('searchCount', this.cat.id === 'process' ? chats.length : 0);
      }
    },
  }
}
</script>
